import React, { ReactNode, useContext, useMemo } from 'react';
import {
  AvtaleApi,
  AvtaleApiInterface,
  BrukerApi,
  BrukerApiInterface,
  PraksiskalenderApi,
  PraksiskalenderApiInterface,
  PraksisstedApi,
  PraksisstedApiInterface,
  PraksistypeApi,
  PraksistypeApiInterface,
  StudiestedApi,
  StudiestedApiInterface,
  VurderingApi,
  VurderingApiInterface,
  PraksisaktivitetVurderingApi,
  PraksisaktivitetVurderingApiInterface,
  VurderingStudentApi,
  VurderingStudentApiInterface,
  DashbordApiInterface,
  DashbordApi,
} from './generated/studiested-generated-api';
import { SessionContext } from './sessionExtension';

export interface StudiestedApiStore {
  praksiskalenderApi: PraksiskalenderApiInterface;
  studiestedApi: StudiestedApiInterface;
  praksisstedApi: PraksisstedApiInterface;
  brukerApi: BrukerApiInterface;
  praksistypeApi: PraksistypeApiInterface;
  vurderingApi: VurderingApiInterface;
  avtaleApi: AvtaleApiInterface;
  praksisaktivitetVurderingApi: PraksisaktivitetVurderingApiInterface;
  vurderingStudentApi: VurderingStudentApiInterface;
  dashbordApi: DashbordApiInterface;
}

export const StudiestedApiContext = React.createContext<StudiestedApiStore>({
  praksiskalenderApi: new PraksiskalenderApi(() => {}),
  studiestedApi: new StudiestedApi(() => {}),
  praksisstedApi: new PraksisstedApi(() => {}),
  brukerApi: new BrukerApi(() => {}),
  praksistypeApi: new PraksistypeApi(() => {}),
  vurderingApi: new VurderingApi(() => {}),
  avtaleApi: new AvtaleApi(() => {}),
  praksisaktivitetVurderingApi: new PraksisaktivitetVurderingApi(() => {}),
  vurderingStudentApi: new VurderingStudentApi(() => {}),
  dashbordApi: new DashbordApi(() => {}),
});

export const StudiestedApiProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const { setKeepAlive } = useContext(SessionContext);

  const studiestedApiStore: StudiestedApiStore = useMemo(
    () => ({
      praksiskalenderApi: new PraksiskalenderApi(setKeepAlive),
      studiestedApi: new StudiestedApi(setKeepAlive),
      praksisstedApi: new PraksisstedApi(setKeepAlive),
      brukerApi: new BrukerApi(setKeepAlive),
      praksistypeApi: new PraksistypeApi(setKeepAlive),
      vurderingApi: new VurderingApi(setKeepAlive),
      avtaleApi: new AvtaleApi(setKeepAlive),
      praksisaktivitetVurderingApi: new PraksisaktivitetVurderingApi(
        setKeepAlive,
      ),
      vurderingStudentApi: new VurderingStudentApi(setKeepAlive),
      dashbordApi: new DashbordApi(setKeepAlive),
    }),
    [setKeepAlive],
  );

  return (
    <StudiestedApiContext.Provider value={studiestedApiStore}>
      {children}
    </StudiestedApiContext.Provider>
  );
};
